import { Component, DoCheck, OnInit, Input } from '@angular/core';
import { ProductsService } from 'src/app/_services/products.service';

@Component({
  selector: 'app-feature-image-v2',
  templateUrl: './feature-image-v2.component.html',
  styleUrls: ['./feature-image-v2.component.scss'],
})
export class FeatureImageV2Component implements OnInit, DoCheck {
  @Input() tempImage: string | null = null;
  placeholderUrl = 'https://preview.keenthemes.com/metronic8/demo2/assets/media/svg/files/blank-image.svg';

  constructor(public _productService: ProductsService) {}

  ngOnInit(): void {
    this.setDefaultFromGallery();
  }

  ngDoCheck(): void {
    this.setDefaultFromGallery();
  }

  private setDefaultFromGallery(): void {
    if (!this._productService.featureImage && this._productService.thImages?.length) {
      this._productService.featureImage = this._productService.thImages[0];
    }
  }
}
